<template>
   <div>
      <div class="leaderBox" v-if="showOrhide">
		  <div class="newtext">新手指引</div>
         <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
         <img src="../../../assets/images/pop/jcht/jcht.png" class="createNxs createNx1" v-if="status==1">
         <div class="createNxbtn" @click="nextcreateNx(status)">
            {{status==1?"我知道了":"我知道了"}}
         </div>
         <div class="bottomTip">
            <el-checkbox v-model="checked">下次不再提示</el-checkbox>
         </div>
      </div>
<!--      <breadcrumb :routerList="[{to:'/establish/contractlist',title:'返利管理'},{title:'基础合同'}]"/>-->
     <Breadtabsheader/>
      <div class="h-piece" style="margin:20px">
         <div class="h-pieceIn2">
            <div class="h-pieceTitle2" style="margin-left:10px">
               <h1>合同基础数据</h1>
            </div>
            <div class="h-pieceCon2">
               <div class="h-formLine n-two">
                  <el-form
                     :model="order"
                     ref="form1"
                     label-position="right"
                     :inline="true"
                     class="demo-ruleForm h-formbLine">
                     <el-form-item
                        prop="year"
                        label="年份"
                        class="h-elformWrap-2"
                        :rules="[{ required: true, message: '请输入年份', trigger: 'change'},]"
                        >
                        <template>
                        <div class="block">
                           <el-date-picker
                              v-model="order.year"
                              type="year"
                              ref="year"
                              placeholder="选择年"
                             value-format="yyyy"
                           >
                           </el-date-picker>
                        </div>
                        </template>
                     </el-form-item>
                     <el-form-item
                        prop="contractName"
                        label="合同名称"
                        :rules="[{ required: true, message: '合同名称不能为空', trigger: 'change'},]"
                        class="h-elformWrap-2">
                        <el-input v-model="order.contractName" ref="contractName"></el-input>
                     </el-form-item>
                     <el-form-item prop="organization" label="销售组织" :rules="[{ required: true, message: '请输入销售组织', trigger: 'change'},]"   class="h-elformWrap-2">
                        <brselect
                           ref="organization"
                           clearable category="FlSalesOrganization_agent"
                           :v="order.organization"
                           v-model="order.organization">
                        </brselect>
                     </el-form-item>
                     <el-form-item prop="completionRateM" label="月度完成率"   :rules="[{ required: true, message: '月度完成率不能为空', trigger: 'change'},]" class="h-elformWrap-2">
                        <el-input v-model="order.completionRateM" ref="completion"  placeholder="输入0~1之间的数字"  maxlength="4"></el-input>
                     </el-form-item>
                     <el-form-item prop="completionRateQ"  label="季度完成率"  :rules="[{ required: true, message: '季度完成率不能为空', trigger: 'change'},]" class="h-elformWrap-2">
                        <el-input
                           v-model="order.completionRateQ" ref="completionRateQ"  maxlength="4"
                           placeholder="输入0~1之间的数字"
                          >
                        </el-input>
                     </el-form-item>
                     <el-form-item
                        prop="completionRateQm"
                        label="季度月完成率"
                        :rules="[{ required: true, message: '请输入季度月完成率', trigger: 'change'},]"
                        class="h-elformWrap-2">
                     <el-input
                        v-model="order.completionRateQm" ref="completionRateQm"  maxlength="4"
                        placeholder="输入0~1之间的数字"
                       >
                     </el-input>
                     </el-form-item>
                        <el-form-item prop="overSamePeriod" label="是否超同期" :rules="[{ required: true, message: '请输入是否超同期', trigger: 'change'},]"   class="h-elformWrap-2" >
                           <brselect
                             ref="overSamePeriod"
                              clearable category="shifou_keyong"
                              :v="order.overSamePeriod"
                              v-model="order.overSamePeriod">
                           </brselect>
                        </el-form-item>
<!--                        <el-form-item-->
<!--                           prop="productType"-->
<!--                           label="产品大类"-->
<!--                           class="h-elformWrap-2">-->
<!--                           <brselect-->
<!--                                   clearable category="product_level"-->
<!--                                   :v="order.productType"-->
<!--                                   v-model="order.productType">-->
<!--                           </brselect>-->
<!--                        </el-form-item>-->
                        <el-form-item prop="exclude" label="不计返利产品"   class="h-elformWrap-2">
                           <el-input v-model="order.exclude" ></el-input>
                        </el-form-item>
                  </el-form>
               </div>
            </div>
         </div>
         <div class="h-table h-mrt30 " style="margin: 20px 20px 0 10px;">
            <div class="h-pieceTitle2 message">
               <h1 class="h1">返利台阶</h1>
            </div>
            <el-table
                  ref="multipleTable"
                  :model="newDate"
                  :data="productlist1"
                  @selection-change="handleSelectionChange"
                  :border="true"
                  stripe
                  style="width: 100%">
               <el-table-column
                        type="index"
                        label="#"
                        width="40">
               </el-table-column>
               <!--<el-table-column-->
                        <!--prop="stepCoefficient"-->
                        <!--label="返利台阶(≥)"-->
                        <!--:show-overflow-tooltip="true"-->
                        <!--width="250">-->
               <!--</el-table-column>-->
               <el-table-column
                       prop="stepCoefficient"
                       label="返利台阶(≥)"
               >
                  <template slot-scope="scope">
                     <el-input v-model="scope.row.stepCoefficient" placeholder="请输入数字" ref="stepCoefficient" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
                  </template>
               </el-table-column>
               <!--<el-table-column-->
                        <!--prop="rebateCoefficient"-->
                        <!--label="返利系数(%)"-->
                        <!--width="250">-->
               <!--</el-table-column>-->
               <el-table-column
                       prop="rebateCoefficient"
                       label="返利系数(%)"
               >
                  <template slot-scope="scope">
                     <el-input v-model="scope.row.rebateCoefficient" placeholder="请输入数字" ref="rebateCoefficient"
                               maxlength="4"
                     ></el-input>
                  </template>
               </el-table-column>
               <!--<el-table-column-->
                        <!--prop="type"-->
                        <!--:show-overflow-tooltip="true"-->
                        <!--label="类型"-->
                        <!--width="250"-->
                        <!--&gt;-->
               <!--</el-table-column>-->
               <el-table-column
                       prop="type"
                       label="类型"
               >
                  <template slot-scope="scope">
                     <el-input v-model="scope.row.type" placeholder="1-月度的/2-季度的" ref="type" oninput="this.value=this.value.replace(/[^1-2]/g, '')"  maxlength="1"></el-input>
                  </template>
               </el-table-column>
               <el-table-column label="操作" fixed="right" width="120">
                  <template slot-scope="scope">
                        <el-button
                           type="text"
                           class="h-tableLink h-btn"
                           width="200"
                           @click="delPlan(scope.$index)">
                           删除
                        </el-button>
                     <el-button
                             type="text"
                             class="h-tableLink h-btn"
                             width="200"
                             @click="copyPlan(scope.row)">
                        复制
                     </el-button>
                  </template>
               </el-table-column>
            </el-table>
               <div  class="h-tableAdd" style="background-color: rgb(94, 182, 233);" @click="addHetong">
                  <a>新增一行</a>
               </div>
         </div>
         
      </div>
	  <div class="h-table h-mrt30 " style="margin: 20px 20px 0 10px;">
		  <div class="anniu" >
		     <el-row>
		        <el-button class="h-btn h-bBtn h-bgwhite"   @click="backtolist">返回</el-button>
		        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submit">确认提交</el-button>
		     </el-row>
		  </div>
	  </div>
   </div>
</template>
<script>
   import ss from '../../../api/SystemService';
   import fanli from "../../../api/loud/fanli/fanli";
   export default {
      data() {
         return {
		 toshow:'rebate1',
         checked:true,
         showOrhide:false,
         status:1,
            newDate:{
               stepCoefficient:null,//返利台阶
               rebateCoefficient:null,//返利系数
               type:null,//类型
         },
         order:{

            completionRateQm:null,//季度月完成率
            organization:null, //组织 是否备货      1：是；0：否    有用的
            year:null,//年
            completionRateQ:null,//季度完成率
            completionRateM:null,//月度完成率
            contractName:null,//合同名称
            productType:null,//产品大类
            exclude:null,//不计返利产品
            overSamePeriod:null,//是否超同期
         },
         //产品list
         productlist1:[
            {
               stepCoefficient: null,
               rebateCoefficient: null,
               type: null
            }
         ],
         }
      },
      mounted(){

      },
	  created() {
			this.showzhezhao()
	  },
      methods: {
		  showzhezhao(){
		  	ss.salesList.toshow(this.toshow).then(rd => {
		  		console.log(rd)
		  	    if(rd == false){
		  	        this.showOrhide = false;
		  	    }else{
		  	        this.showOrhide = true;
		  	    }
		  	})
		  },
         closeIt(){
            this.showOrhide = false;
            if(this.checked){
			   ss.salesList.toshow(this.toshow,this.checked).then(rd => {
			   	console.log(rd)
			   	this.showOrhide = false;
			   })
            }else{
				ss.salesList.toshow(this.toshow,this.checked).then(rd => {
					console.log(rd)
					this.showOrhide = false;
				})
			}
         },

         nextcreateNx(i){
            console.log(i)
            if(this.status ==1){
               if(this.checked){
					 ss.salesList.toshow(this.toshow,this.checked).then(rd => {
					 	console.log(rd)
					 	this.showOrhide = false;
					 })
               }else{
				   ss.salesList.toshow(this.toshow,this.checked).then(rd => {
				   	console.log(rd)
				   	this.showOrhide = false;
				   })
			   }
            }
         },
         // 取消方法
         backtolist(){
            this.$router.go(-1);
         },
         //删除
         delPlan(index){
            this.$msg.confirm("确认删除？",()=>{
               this.productlist1.splice(index, 1)
            })
         },
         //复制
         copyPlan(v){
            var list ={
               stepCoefficient:v.stepCoefficient,
               rebateCoefficient:v.rebateCoefficient,
               type:v.type,
            }
            this.productlist1.push(list)
         },
         addHetong(){
           var list ={
              stepCoefficient:'',
              rebateCoefficient:'',
              type:''
           }
            this.productlist1.push(list)
         },
         handleSelectionChange(val){
            this.multipleSelection = val;
         },
         getUuid(){
            return this.$util.getUuid();
         },
         //this.$msg.msge("请先完善基础合同信息")
         //提交
         submit(){
            console.log(this.$refs.rebateCoefficient.value,"返利系数");
            console.log(this.$refs.completionRateQm.value);
            if(this.$refs.completion.value==""||this.$refs.completion.value==null){
               this.$msg.msge("请先填写月度完成率")
            }else if(this.$refs.year.value==""||this.$refs.year.value==null){
               this.$msg.msge("请先填写年份")
            }else if(this.$refs.contractName.value==""||this.$refs.contractName.value==null){
               this.$msg.msge("请先填写合同名称")
            }
            else if(this.order.organization==""||this.order.organization==null){
               this.$msg.msge("请先填写销售组织")
            }
            else if(this.$refs.completionRateQ.value==""||this.$refs.completionRateQ.value==null){
               this.$msg.msge("请先填写季度完成率")
            }else if(this.$refs.completionRateQm.value==""||this.$refs.completionRateQm.value==null){
               this.$msg.msge("请先填写季度月完成率")
            }
            else if(this.order.overSamePeriod==""||this.order.overSamePeriod==null){
               this.$msg.msge("请先填写是否超同期")
            }
            else if(this.$refs.stepCoefficient.value==""||this.$refs.stepCoefficient.value==null){
               this.$msg.msge("请先填写返利台阶")
            }
            else if(this.$refs.rebateCoefficient.value==""||this.$refs.rebateCoefficient.value==null){
               this.$msg.msge("请先填写返利系数")
            }else if(this.$refs.type.value==""||this.$refs.type.value==null){
               this.$msg.msge("请先填写类型")
            }
            else if(this.$refs.rebateCoefficient.value>100||this.$refs.rebateCoefficient.value<0){
               this.$msg.msge("请保证返利系数在规定范围内")
            }
            else if(this.$refs.completion.value>1||this.$refs.completion.value<0){
               this.$msg.msge("请保证月度完成率在规定范围内")
            }else if(this.$refs.completionRateQ.value>1||this.$refs.completionRateQ.value<0){
               this.$msg.msge("请保证季度完成率在规定范围内")
            }else if(this.$refs.completionRateQm.value>1||this.$refs.completionRateQm.value<0){
               this.$msg.msge("请保证季度月完成率在规定范围内")
            }
            else{
               console.log('提交数据')
               this.tijiaotongdao();

            }
         },
         //提交通道
         tijiaotongdao(){
            console.log('jinrukankanfanhui')
            this.order.goalList=this.productlist1;
            this.order.id=this.getUuid();
            //提交
            ss.fanli.querentijia(this.order).then(rd => {
               //提交返利列表

               console.log('kankanfanhui')
               if(rd.f==true){
                  this.$msg.alerts("提交成功！",()=>{

                     //跳转
                     //this.$router.push({path:'/pricenew'})
                  })
               }
            })



         },






      }
   }
</script>
<style scoped>
   .anniu {
      display: flex;
      justify-content: center;
      margin-top: 20px;
   }
   .DshuR {
      width: 100%;
      height: 100%;
      border: none;
   }
   .n-two .h-formbLine .h-elformWrap-2 {
      width: 33.333%;
   }
</style>
<style>
    .n-two .h-formbLine .el-form-item__content .el-select,
    .n-two .el-form .h-formbLine .el-form-item__content .el-select {
        width: 0;
    }
    .n-two .h-formbLine .el-form-item__label {
        width: 43%;
    }
    .n-two .h-formbLine .el-form-item__content {
        width: 57%;
    }
</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
		z-index: 999999;
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;

		}
		.createNxs{
			position: absolute;
			z-index: 1;

		}
		.createNx1{
			top: -0.7rem;
			left: 0;
		}
		
		.createNxbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.75rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
			z-index: 2;
		}
	}
</style>
